export const UNAVAILABLE_REASON = {
  CLOSED_DAY: 'CLOSED_DAY',
  NO_SCHEDULE: 'NO_SCHEDULE',
  CUT_OFF_PASSED: 'CUT_OFF_PASSED',
  SOLD_OUT: 'SOLD_OUT',
  HELD_IN_CART: 'HELD_IN_CART',
  NOT_ENOUGH_QTY: 'NOT_ENOUGH_QTY',
  // Bukan soal stok, tapi hasil cek tidak bisa ditampilkan
  FILTER_CHANGED: 'FILTER_CHANGED',
  REQUEST_FAILED: 'REQUEST_FAILED'
}

/**
 * Alasan produk ber-schedule tidak bisa dibooking pada tanggal terpilih.
 * @param {Object} params
 * @param {Array} params.schedules semua sesi dari API untuk tanggal tersebut
 * @param {Array} params.openSchedules sesi yang belum lewat cut-off, sudah punya realtime_avb
 * @param {Number} params.qty jumlah unit yang diminta
 * @param {Boolean} params.isClosedDay POS tidak beroperasi di hari tersebut
 * @returns {Object|null} null jika ada sesi yang cukup, selain itu { code, remaining, cutOffHours, lastSessionStart }
 */
export function getScheduleUnavailableReason({ schedules, openSchedules, qty, isClosedDay }) {
  const all_schedules = Array.isArray(schedules) ? schedules : []
  const open_schedules = Array.isArray(openSchedules) ? openSchedules : []

  if (all_schedules.length == 0) {
    return { code: isClosedDay ? UNAVAILABLE_REASON.CLOSED_DAY : UNAVAILABLE_REASON.NO_SCHEDULE }
  }

  if (open_schedules.length == 0) {
    return Object.assign({ code: UNAVAILABLE_REASON.CUT_OFF_PASSED }, getCutOffInfo(all_schedules))
  }

  // Satu booking hanya memakai satu sesi, jadi yang menentukan adalah sesi dengan sisa terbanyak
  return getStockReason({
    apiAvailability: maxOf(open_schedules.map(getApiAvailability)),
    realtimeAvailability: maxOf(open_schedules.map(sch => Number(sch.realtime_avb))),
    qty
  })
}

/**
 * Alasan produk tanpa schedule tidak bisa dibooking pada tanggal terpilih.
 * @param {Object} params
 * @param {Object} params.product data produk dari API (availability / master_availability_reference_data)
 * @param {Number} params.realtimeAvailability sisa stok setelah dikurangi isi cart
 * @param {Number} params.qty jumlah unit yang diminta
 * @returns {Object|null} null jika stok cukup, selain itu { code, remaining }
 */
export function getStandardUnavailableReason({ product, realtimeAvailability, qty }) {
  return getStockReason({
    apiAvailability: getApiAvailability(product),
    realtimeAvailability: Number(realtimeAvailability) || 0,
    qty
  })
}

// Stok versi server (belum dikurangi cart) supaya bisa dibedakan dengan stok yang habis karena cart
function getApiAvailability(item) {
  if (!item) return 0
  const master_refs = item.master_availability_reference_data
  if (item.use_master_availability && Array.isArray(master_refs) && master_refs.length > 0) {
    // Unit yang bisa dibentuk dibatasi oleh master availability yang paling sedikit
    return Math.min(...master_refs.map(ref => Math.floor(Number(ref.availability) / Number(ref.qty))))
  }
  return Number(item.availability) || 0
}

function getStockReason({ apiAvailability, realtimeAvailability, qty }) {
  if (realtimeAvailability >= Number(qty)) return null
  if (realtimeAvailability > 0) return { code: UNAVAILABLE_REASON.NOT_ENOUGH_QTY, remaining: realtimeAvailability }
  // Stok di server masih ada tapi habis di sisi guest: sisanya sudah dipegang cart-nya sendiri
  if (apiAvailability > 0) return { code: UNAVAILABLE_REASON.HELD_IN_CART }
  return { code: UNAVAILABLE_REASON.SOLD_OUT }
}

// Sesi terakhir yang dijadikan acuan karena itu kesempatan booking paling akhir di tanggal tersebut
function getCutOffInfo(schedules) {
  const last_session = schedules
    .filter(sch => sch.schedule_start)
    .reduce((latest, sch) => (!latest || sch.schedule_start > latest.schedule_start ? sch : latest), null)

  return {
    cutOffHours: last_session ? Number(last_session.cut_off) || 0 : 0,
    lastSessionStart: last_session ? last_session.schedule_start : ''
  }
}

function maxOf(numbers) {
  const valid_numbers = numbers.filter(number => !isNaN(number))
  return valid_numbers.length > 0 ? Math.max(...valid_numbers) : 0
}



// WEBPACK FOOTER //
// ./src/utils/activityAvailability.js